import React, { FC, ReactNode } from 'react';
import { Box, Popover } from '@mui/material';

export const FILTER_TRIGGER_CLASS =
  'inline-flex items-center gap-2 h-10 px-[13px] border rounded-[10px] whitespace-nowrap transition-colors border-border-token dark:border-muted bg-surface text-text-2 hover:text-accent-text hover:border-accent';

export const FilterTriggerIcon = (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
    <path d="M4 6h16M7 12h10M10 18h4" />
  </svg>
);

export const FilterCountBadge: FC<{ count: number }> = ({ count }) =>
  count > 0 ? (
    <span
      className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-[5px] rounded-full bg-accent font-bold"
      style={{ fontSize: 10.5, color: 'var(--rail)' }}
    >
      {count}
    </span>
  ) : null;

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onClearAll: () => void;
  activeCount: number;
  children: ReactNode;
}

export const FilterPanel: FC<Props> = ({ anchorEl, onClose, onClearAll, activeCount, children }) => (
  <Popover
    keepMounted
    open={!!anchorEl}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: -8, horizontal: 'right' }}
    slotProps={{
      paper: {
        sx: {
          width: 380,
          maxWidth: 'calc(100vw - 24px)',
          borderRadius: '12px',
          border: '1px solid var(--border)',
          boxShadow: 'var(--sh-2)',
          background: 'var(--surface)',
          backgroundImage: 'none',
          overflow: 'visible',
        },
      },
    }}
  >
    <Box className="flex items-center gap-2.5 px-4 py-3.5 border-b border-border-token">
      <b className="flex-1 text-[13.5px] font-bold text-text-1">More filters</b>
      <FilterCountBadge count={activeCount} />
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="w-[26px] h-[26px] rounded-lg bg-surface-2 text-text-1 inline-flex items-center justify-center"
      >
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 6 18 18M18 6 6 18" />
        </svg>
      </button>
    </Box>
    <Box className="p-4 flex flex-col gap-4 max-h-[60vh] overflow-y-auto">{children}</Box>
    <Box className="flex items-center gap-3 px-4 py-3 border-t border-border-token bg-page rounded-b-xl">
      <button
        type="button"
        onClick={onClearAll}
        className="h-[34px] px-3 rounded-lg text-accent-text font-bold underline"
        style={{ fontSize: 12.5 }}
      >
        Clear all
      </button>
      <span className="flex-1" />
      <button
        type="button"
        onClick={onClose}
        className="h-[34px] px-[18px] rounded-lg bg-accent font-bold"
        style={{ fontSize: 12.5, color: 'var(--rail)' }}
      >
        Done
      </button>
    </Box>
  </Popover>
);
